"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataSourceValuesMock = void 0;
var paginateAnything_1 = require("../../functions/util/paginateAnything");
var colors_1 = require("../mockData/dataSourceValues/colors");
var participants_1 = require("../mockData/dataSourceValues/participants");
var workLocations_1 = require("../mockData/dataSourceValues/workLocations");
function getDataSourceValuesMock(args) {
    var data;
    switch (args.dataSourceKey) {
        case "123423":
            data = colors_1.colors;
            break;
        case "WORK_LOCATION":
            data = workLocations_1.workLocations;
            break;
        case "PARTICIPANT":
            data = participants_1.participants;
            break;
        default:
            data = paginateAnything_1.paginateAnything([]);
    }
    return Promise.resolve(data);
}
exports.getDataSourceValuesMock = getDataSourceValuesMock;
//# sourceMappingURL=getDataSourceValuesMock.js.map